(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["zhopu-header-country"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',event=>{
    document.querySelectorAll('[data-header-country][open]').forEach(node=>{
      if(!node.contains(event.target))node.open=false;
    });
  });
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-header-country][open]').forEach(node=>{
      node.open=false;node.querySelector('summary').focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
